export default __webpack_public_path__ + "static/The Home_image 1@2x-f8b1e63a1556ad9a25ea519c90f9ec2d.jpg";